/*
 * CAPTURE-OWNED MODULE
 * What a Template Studio "Delete zone" removes, and how to name it.
 *
 * Mirrors capture-app services/templateZoneDeletion.ts (the server decides;
 * this copy only words the confirmation): deleting a field's last value zone
 * also deletes that field's anchor and region zones; an anchor, a region or
 * one page's line_items_table zone goes alone.
 */

import { zoneTypeName } from './zoneLabels';

/** Zones removed with `target`, target first. */
export function zonesRemovedWith(target, zones) {
  if (!target) return [];
  if (target.zone_type !== 'field' || !target.field_id) return [target];
  const sameField = zones.filter(z => z.field_id === target.field_id && z.id !== target.id);
  if (sameField.some(z => z.zone_type === 'field')) return [target];
  return [target, ...sameField.filter(z => z.zone_type === 'anchor' || z.zone_type === 'region')];
}

/**
 * The confirmation for a delete that removes more than the clicked zone, or
 * null when the zone goes alone (no confirmation).
 */
export function cascadeConfirmMessage(target, zones, fields) {
  const removed = zonesRemovedWith(target, zones);
  if (removed.length < 2) return null;
  const field = fields.find(f => f.id === target.field_id);
  const name = field?.label || field?.field_key || 'this field';
  const others = removed.slice(1).map(z => `${zoneTypeName(z.zone_type)} zone`);
  const list = others.length === 1 ? others[0] : `${others.slice(0, -1).join(', ')} and ${others[others.length - 1]}`;
  return `Delete the value zone for "${name}"?\n\nThis also removes its ${list}.`;
}
